import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
  import DragAndDropUpload from '@/ui/components/common/DragAndDropUpload.vue';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';

  interface ExistingFile {
    name: string;
    url: string;
    id: number;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WordTemplateUpload',
  props: {
    existingFile: null
  },
  emits: ["file-change", "file-deleted", "uploading-change"],
  setup(__props: any, { emit }: { emit: ({(e: 'file-change', file: File | null): void;
                            (e: 'file-deleted'): void;
                            (e: 'uploading-change', isUploading: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    existingFile?: ExistingFile | null;
  };

  

  

  const isUploading = ref(false);
  const uploadedFile = ref<File | null>(null);
  const uploadedFileName = ref<string | null>(null);

  const uploadIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M35.2779 22.0822H26.1112V19.9987H30.1853C32.8971 19.9987 34.2721 16.6326 32.3433 14.6663L22.1581 4.24885C20.9613 3.0248 19.0325 3.03131 17.8357 4.24885L7.65054 14.6663C5.73446 16.6261 7.09672 19.9987 9.8149 19.9987H13.889V22.0822H4.7223C3.03538 22.0822 1.66675 23.482 1.66675 25.2074V33.5414C1.66675 35.2667 3.03538 36.6666 4.7223 36.6666H35.2779C36.9648 36.6666 38.3334 35.2667 38.3334 33.5414V25.2074C38.3334 23.482 36.9648 22.0822 35.2779 22.0822ZM9.8149 16.8735L20.0001 6.45604L30.1853 16.8735H23.0556V27.2909H16.9445V16.8735H9.8149ZM35.2779 33.5414H4.7223V25.2074H13.889V27.2909C13.889 29.0163 15.2576 30.4161 16.9445 30.4161H23.0556C24.7426 30.4161 26.1112 29.0163 26.1112 27.2909V25.2074H35.2779V33.5414ZM32.7316 29.3744C32.7316 30.2403 32.0504 30.937 31.2038 30.937C30.3571 30.937 29.676 30.2403 29.676 29.3744C29.676 28.5084 30.3571 27.8118 31.2038 27.8118C32.0504 27.8118 32.7316 28.5084 32.7316 29.3744Z" fill="#7A7A7A"/>
    </svg>
  `;

  const MAX_SIZE_MB = 10;

  const handleFileUpload = async (files: File[]) => {
    const file = files[0];
    if (!file) { return; }

    const fileSizeMb = file.size / (1024 * 1024);
    if (fileSizeMb > MAX_SIZE_MB) {
      toasted.error(t('upload.errors.file-too-large', { maxSizeMb: String(MAX_SIZE_MB) }));
      return;
    }

    if (!file.name.toLowerCase().endsWith('.docx')) {
      toasted.error(t('upload.errors.invalid-docx'));
      return;
    }

    isUploading.value = true;
    emit('uploading-change', true);
    setTimeout(() => {
      uploadedFile.value = file;
      isUploading.value = false;
      emit('uploading-change', false);
      toasted.success(t('upload.success'));
    }, 1500);
  };

  const handleDelete = () => {
    uploadedFile.value = null;
    uploadedFileName.value = null;
    emit('file-deleted');
    toasted.success(t('upload.deleted'));
  };

  onMounted(() => {
    if (props.existingFile?.name) {
      uploadedFileName.value = props.existingFile.name;
    }
  });

  watch(() => props.existingFile, newValue => {
    if (newValue?.name) {
      uploadedFileName.value = newValue.name;
    } else {
      uploadedFileName.value = null;
      uploadedFile.value = null;
    }
  });

  watch(uploadedFile, newFile => {
    emit('file-change', newFile);
  });

return { __sfc: true,props, emit, isUploading, uploadedFile, uploadedFileName, uploadIcon, MAX_SIZE_MB, handleFileUpload, handleDelete, DragAndDropUpload }
}

})